import { render, staticRenderFns } from "./CorrectionHistory.vue?vue&type=template&id=2346a8fb&scoped=true&"
import script from "./CorrectionHistory.vue?vue&type=script&lang=js&"
export * from "./CorrectionHistory.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionHistory.vue?vue&type=style&index=0&id=2346a8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346a8fb",
  null
  
)

export default component.exports